// custom-cloudflare.js
// Gestione solo cf_country via Worker + helper Promise

// -----------------------------
// Utility cookie
// -----------------------------
function getCloudflareCountryFromCookie() {
  var match = document.cookie.match(/(?:^|; )cf_country=([^;]+)/);
  return match ? match[1] : null;
}

// -----------------------------
// Funzione che garantisce la country
// (usa cookie; chiama il Worker solo se serve)
// -----------------------------
async function ensureCloudflareCountry() {
  var cookieCountry = getCloudflareCountryFromCookie();

  // 1) Se abbiamo già la country nei cookie → stop, niente Worker
  if (cookieCountry) {
    window.cloudflareCountry = cookieCountry;
    return { country: cookieCountry };
  }

  // 2) Nessuna country → chiamiamo il Worker dedicato
  var response = await fetch('/workers/set-cf-cookies', {
    method: 'GET',
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error('Errore chiamando /workers/set-cf-cookies: ' + response.status);
  }

  var data;
  try {
    data = await response.json();
  } catch (e) {
    // Se per qualche motivo non arriva JSON valido, non spacchiamo la pagina
    return { country: getCloudflareCountryFromCookie() || null };
  }

  var resolvedCountry =
    (data && data.country) ||
    getCloudflareCountryFromCookie() ||
    null;

  window.cloudflareCountry = resolvedCountry;

  return {
    country: resolvedCountry
  };
}

// -----------------------------
// Bootstrap iniziale dai cookie
// (best effort sincrono)
// -----------------------------
window.cloudflareCountry = getCloudflareCountryFromCookie() || null;

// -----------------------------
// Promise LAZY + getter globale
// -----------------------------
var _cloudflareInfoPromise = null;

/**
 * Ritorna una Promise con { country }.
 * - Prima chiamata → usa cookie e chiama il Worker SOLO se serve.
 * - Chiamate successive → riusano la stessa Promise.
 */
window.getCloudflareInfo = function () {
  if (_cloudflareInfoPromise) {
    return _cloudflareInfoPromise;
  }

  _cloudflareInfoPromise = ensureCloudflareCountry()
    .then(function (info) {
      window.cloudflareInfo = info;
      return info;
    })
    .catch(function (err) {
      // In caso di errore azzeriamo la cache così possiamo riprovare in futuro
      _cloudflareInfoPromise = null;
      throw err;
    });

  // compat con eventuale codice legacy
  window.cloudflareInfoPromise = _cloudflareInfoPromise;

  return _cloudflareInfoPromise;
};

// ---------------------------------------------------
// Helper globale: runWithCfInfo(handlerOrOptions, handler)
// ---------------------------------------------------
// Uso pratico:
//   runWithCfInfo(function (cfInfo) { ... });
//   runWithCfInfo({ fallbackOnError: false }, function (cfInfo) { ... });
//
// cfInfo = { country: 'IT' } oppure null se fallback/error
window.runWithCfInfo = function runWithCfInfo(options, handler) {
  // Permettiamo chiamata anche come runWithCfInfo(handler)
  if (typeof options === 'function') {
    handler = options;
    options = {};
  } else {
    options = options || {};
  }

  var fallbackOnError = options.fallbackOnError !== false;

  if (typeof handler !== 'function') {
    return Promise.resolve(null);
  }

  if (typeof window.getCloudflareInfo !== 'function') {
    // Nessun CF disponibile → chiamiamo comunque l'handler con null
    try {
      handler(null);
      return Promise.resolve(null);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  var p;
  try {
    p = window.getCloudflareInfo();
  } catch (err) {
    if (fallbackOnError) {
      handler(null);
      return Promise.resolve(null);
    }
    return Promise.reject(err);
  }

  if (!p || typeof p.then !== 'function') {
    try {
      handler(null);
      return Promise.resolve(null);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  return p.then(function (info) {
    handler(info || null);
    return info || null;
  }).catch(function (err) {
    if (fallbackOnError) {
      handler(null);
      return null;
    }
    throw err;
  });
};
